import React from 'react';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import WhyChooseSection from '../components/WhyChooseSection';
import StatsSection from '../components/StatsSection';
import ContactSection from '../components/ContactSection';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <ServicesSection />
      <WhyChooseSection />
      {/* <StatsSection /> */}
      {/* <ContactSection /> */}
    </>
  );
};

export default HomePage;